import {stringify} from 'query-string';
import {readBid} from '@px/storage/bid';
import {readUsedUIDs} from '@px/storage/uids';
import {genSystemDeviceForHttp} from '@px/helper/device';

const ET_URL = 'https://et.phemex.com/web.gif?';

const showLog = localStorage.getItem('et_show_log') === 'Y';

// TODO: 全埋点

const profile = {
  bid: readBid(),
  t0: Date.now(),
};

export function track(eventName: string, params: Record<string, any>) {
  collect(eventName, params);
}

export function pageView(params: Record<string, any>) {
  collect('page_view', params);
}

export function setProfile(record: Record<string, any>) {
  Object.assign(profile, record);
  if (showLog) {
    console.log(`%c [ET] profile:`, 'color:#0f0;');
    console.table(profile);
  }
}

function collect(eventName: string, params: Record<string, any>) {
  const localUIDs = readUsedUIDs();
  const data = {
    ...profile,
    uid: localUIDs[0] || '',
    time: Date.now(),
    event: eventName,
    url: window.location.href,
    referrer: window.document.referrer,
    context: {...params, device: genSystemDeviceForHttp()},
  };
  if (showLog) {
    console.log(`%c [ET] event: ${eventName}`, 'color:#0f0;');
    console.table(data);
  }
  // TODO: upload as array
  new Image().src = ET_URL + stringify({d: encodeData(data)});
}

/**
 * use this to make a Base64 encoded string URL friendly,
 * i.e. '+' and '/' are replaced with '-' and '_' also any trailing '='
 * characters are removed
 */
function encodeData(data) {
  const jsonData = JSON.stringify(data);
  const validBtoa = (str: string) => {
    return [
      [/≤/g, '<='],
      [/≥/g, '>='],
    ].reduce((p, c: [RegExp, string]) => p.replace(c[0], c[1]), str);
  };

  const base64 = window.btoa(validBtoa(jsonData));
  return [
    [/\+/g, '-'],
    [/\//g, '_'],
    [/=+$/, ''],
  ].reduce((p, c: [RegExp, string]) => p.replace(c[0], c[1]), base64);
}
